import { IFormBuilder } from '../IFormBuilder';
import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { FormControl, ValidatorFn } from '@angular/forms';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { FaqItem } from '../../faq-item';

interface IFaqItemFormBuilder extends IFormBuilder<FaqItemControls> {
  init(faqItem: { question: string; answer: string }): IFaqItemFormBuilder;

  build(): IGenericBaryFormGroup<FaqItemControls>;
}

export type FaqItemControls = {
  question: FormControl;
  answer: FormControl;
};

export class FaqItemFormBuilder implements IFaqItemFormBuilder {
  private formName = 'themeFaqItemForm';
  private controls?: FaqItemControls;
  private validators?: ValidatorFn[];

  constructor(private bcf: BaryFormFactoryService) {}

  init(faqItem: FaqItem): FaqItemFormBuilder {
    this.controls = this.bcf.makeFaqItemControls(faqItem);
    this.applyTransporterConfiguration();
    return this;
  }

  private applyTransporterConfiguration(): void {
    this.validators = [];
  }

  build(): IGenericBaryFormGroup<FaqItemControls> {
    return new GenericBaryFormGroup<FaqItemControls>(this.formName, this.controls!, this.validators);
  }
}
